import React from 'react'
import { Field, useFormikContext } from 'formik'
import { AddressField } from 'civic-champs-shared/formik/components'
import { AddressFieldProps } from 'civic-champs-shared/formik/components/AddressField'
import { useFeatureEnabled } from 'core/feature/hooks'
import { GeoCoordinates } from 'civic-champs-shared/core/location/utils'

type OrganizationAddressFieldProps = Partial<
  Pick<
    AddressFieldProps,
    | 'showRadius'
    | 'fieldTitle'
    | 'label'
    | 'hideMap'
    | 'placeholder'
    | 'loadLocationFromAddress'
    | 'vertical'
    | 'halfMap'
    | 'smaller'
    | 'labelShrink'
    | 'compactSlider'
    | 'autocompleteDisabled'
    | 'className'
  >
>

const getReferenceCoordinates = (coordinates?: GeoCoordinates) => {
  if (coordinates?.lat == null || coordinates?.lng == null) {
    return undefined
  }
  if (coordinates.lat === 0 && coordinates.lng === 0) {
    return undefined
  }
  return { lat: coordinates.lat, lng: coordinates.lng }
}

export default function OrganizationAddressField(props: OrganizationAddressFieldProps) {
  const plusCodesEnabled = useFeatureEnabled('PlusCodes')
  const { values } = useFormikContext<{ address?: { geofencing?: { location?: { coordinates?: GeoCoordinates } } } }>()
  const referenceCoordinates = getReferenceCoordinates(values?.address?.geofencing?.location?.coordinates)

  return (
    <Field
      {...props}
      name="address"
      component={AddressField}
      allowPlusCode={plusCodesEnabled}
      referenceCoordinates={referenceCoordinates}
    />
  )
}
